import script from "./UserStart.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserStart.vue?vue&type=script&setup=true&lang=ts"

import "./UserStart.vue?vue&type=style&index=0&id=4ec7fed0&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ec7fed0"]])

export default __exports__